import React from "react";
import { FaEnvelope, FaHeadset, FaPhoneAlt } from "react-icons/fa";

const Support24x7 = () => {
  return (
    <div className="container-fluid py-3 py-md-4 px-2 px-sm-3">
      <div className="card shadow-sm border-0">
        <div className="card-body p-3 p-md-4">
          <div className="d-flex align-items-center gap-2 mb-2">
            <FaHeadset style={{ color: "#1e3686" }} />
            <h5 className="mb-0">Support 24/7</h5>
          </div>
          <p className="text-muted mb-3">
            Contact our support team anytime using the details below.
          </p>
          <div className="d-flex flex-column gap-2">
            <a
              href="mailto:support@complymax.co.in"
              className="d-inline-flex align-items-center gap-2 text-decoration-none"
              style={{ color: "#1e3686", fontWeight: 500, width: "fit-content" }}
            >
              <FaEnvelope />
              <span>support@complymax.co.in</span>
            </a>
            <a
              href="tel:01147019306"
              className="d-inline-flex align-items-center gap-2 text-decoration-none"
              style={{ color: "#1e3686", fontWeight: 500, width: "fit-content" }}
            >
              <FaPhoneAlt />
              <span>01147019306</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support24x7;
